export const DISCLOSURE_SECTIONS = [
  {
    title: '1. Authorization and Transfer of Ownership',
    body: `By signing this document, the Customer confirms they have full legal authority to release all equipment listed in the inventory. The Customer agrees that ownership of all items is irrevocably transferred and assigned to EcoTech Electronics upon pickup or receipt. The Customer authorizes EcoTech Electronics to handle, process, recycle, resell, or destroy the equipment in accordance with all applicable local, state, and federal regulations.`,
  },
  {
    title: '2. Data Destruction and Liability',
    body: `The Customer acknowledges that any data-bearing devices (including but not limited to hard drives, SSDs, and mobile devices) are approved for data destruction. The Customer understands that all data will be rendered unrecoverable through industry-standard processes.`,
    bullets: [
      'Chain of Custody: EcoTech Electronics shall maintain a secure chain of custody throughout the process.',
      'Certification: A Certificate of Destruction will be provided to the Customer upon the successful completion of physical destruction process.',
    ],
  },
  {
    title: '3. Inventory and Condition',
    body: `EcoTech Electronics is not responsible for discrepancies in customer-provided inventories or for any pre-existing damage to the equipment. It is the responsibility of the Customer to ensure the inventory list accurately reflects the items being released.`,
  },
  {
    title: '4. Limitation of Liability',
    body: `Liability for EcoTech Electronics is strictly limited to the services performed. EcoTech Electronics shall not be held liable for any indirect, incidental, or consequential damages arising from the processing or disposal of the equipment once ownership has been transferred.`,
  },
];

export default function DisclosureText() {
  return (
    <div className="space-y-4 text-sm text-foreground leading-relaxed">
      {DISCLOSURE_SECTIONS.map((section) => (
        <div key={section.title}>
          <p className="font-semibold mb-1">{section.title}</p>
          <p className="text-muted-foreground">{section.body}</p>
          {section.bullets && (
            <ul className="mt-2 ml-4 list-disc space-y-1 text-muted-foreground">
              {section.bullets.map((b, i) => (
                <li key={i}>{b}</li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
}
